import { render } from "./UserApps.vue?vue&type=template&id=999975ba"
import script from "./UserApps.vue?vue&type=script&lang=js"
export * from "./UserApps.vue?vue&type=script&lang=js"
script.render = render

export default script